<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('temporalities')"
      :columns="columns"
      :column_search="false"
      :extra_buttons="extra_buttons"
      resource_url="/museum/temporality/datatables"
    ></generic-table>
  </div>

  <temporality-modal ref="temporality_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
  api_host,
} from "@/utils";
import TemporalityModal from "./temporality_modal/Index.vue";

export default {
  name: "TemporalityDatatable",
  components: { GenericTable, TemporalityModal },
  data() {
    let v = this;
    return {
      api_host,
      extra_buttons: [
        {
          // text: v.$t("add"),
          tooltip: v.$t("add"),
          text: "",
          icon: "fa fa-plus",
          class: "is-secondary is-rounded",
          click: this.create,
        },
      ],
      columns: [
        {
          title: v.$t("name"),
          name: "name",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.name || "";
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.temporality_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete temporality?"),
                    v,
                    () => {
                      del("/museum/temporality", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    format_currency,
    create() {
      let v = this;
      v.$refs.temporality_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
